import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useHistory, useParams } from "react-router-dom";
import { isEmpty } from "lodash";
import { fetchBatch, breakBatch } from "Services/delivery.services";
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";
import "../parcel-tracking-view.scss";
import { toaster } from "Helpers/toaster";
import { decode } from "Helpers/enc";
import ParcelTrackingBatchesViewComponent from "Components/delivery-management/parcel-tracking-view/batches-view-component";
import { listServicePoints } from "Services/delivery-settings.services";

const ParcelTrackingBatchesViewPage = ({}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const decodedBatchID = decode(id);
  const [batchDetails, setBatchDetails] = useState<any>([]);
  const [sortingHubOptions, setSortingHubOptions] = useState<any>([]);

  useEffect(() => {
    fetchBatchDetails();
    handleListingSortingHub();
  }, []);

  const fetchBatchDetails = async () => {
    const responseData = await fetchBatch(decodedBatchID);
    setBatchDetails(responseData);
  };

  const handleListingSortingHub = async () => {
    const responseData = await listServicePoints({active: true});

    if (!isEmpty(responseData) && !responseData.error) {
      setSortingHubOptions(responseData);
    } else {
      console.log("Failed to fetch origin hubs.");
    }
  };

  const handleBreakBatch = async (payload: any) => {
    const responseData = await breakBatch(
      decodedBatchID,
      payload.orderIDs,
      payload.handoverPointID,
    );

    if (responseData && !responseData.error) {
      toaster("success", "Batch broke successfully");
      history.push(`/delivery-management/parcel-tracking?tabKey=2`);
    } else {
      toaster("error", responseData.error.message.message);
    }
  };

  return (
    <div>
      <Helmet>
        <title>{t("title.deliveryManagement")}</title>
      </Helmet>

      <ModuleTitleBar
        titleText={t("title.deliveryManagement")}
        haveSubtitle
        subtitleText={t("title.sorting")}
      />
      <ParcelTrackingBatchesViewComponent
        handoverOptions={sortingHubOptions}
        info={batchDetails}
        onBreakBatches={handleBreakBatch}
      />
    </div>
  );
};

export default ParcelTrackingBatchesViewPage;
